import React from "react";
import "./invoicePreview.scss";

export const InvoicePreview = () => {
    return (<page size="A4" className={"invoice-preview-component"}>
            {/* Header */}
            <table
                width="100%"
                border={0}
                cellPadding={0}
                cellSpacing={0}
                align="center"
                className="fullTable"
                bgcolor="#e1e1e1"
                style={{borderTop: "10px solid #F2B34C"}}
            >
                <tbody>
                <tr>
                    <td>
                        <table
                            width="100%"
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            align="center"
                            className="fullTable"
                            bgcolor="#ffffff"
                        >
                            <tbody>
                            <tr className="hiddenMobile">
                                <td height={40}/>
                            </tr>
                            <tr className="visibleMobile">
                                <td height={30}/>
                            </tr>
                            <tr>
                                <td>
                                    <table
                                        width="80%"
                                        border={0}
                                        cellPadding={0}
                                        cellSpacing={0}
                                        align="center"
                                        className="fullPadding"
                                    >
                                        <tbody>
                                        <tr>
                                            <td>
                                                <table
                                                    width="20%"
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    align="left"
                                                    className="invoice-col"
                                                >
                                                    <tbody>
                                                    <tr>
                                                        <td align="left">
                                                            {" "}
                                                            <img
                                                                src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png"
                                                                width={64}
                                                                height={64}
                                                                alt="logo"
                                                                border={0}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr className="hiddenMobile">
                                                        <td height={40}/>
                                                    </tr>
                                                    <tr className="visibleMobile">
                                                        <td height={20}/>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 12,
                                                                color: "#5b5b5b",
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                lineHeight: 18,
                                                                verticalAlign: "top",
                                                                textAlign: "left",
                                                                display: "none"
                                                            }}
                                                        >
                                                            {/* can be text here */}
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                <table
                                                    width="33%"
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    align="left"
                                                    className="invoice-col"
                                                >
                                                    <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 12,
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                color: "#5b5b5b",
                                                                lineHeight: 20,
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            Happy Gastro Hungary Kft.
                                                            <br/>
                                                            28735636-1-41
                                                            <br/> 2000 Szentendre, Duna korzó 11.
                                                            <br/>
                                                            <a
                                                                href="#"
                                                                style={{
                                                                    color: "#ff0000",
                                                                    textDecoration: "underline"
                                                                }}
                                                            >
                                                                info@happygastro.hu
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                <table
                                                    width="33%"
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    align="right"
                                                    className="invoice-col"
                                                >
                                                    <tbody>
                                                    <tr className="visibleMobile">
                                                        <td height={20}/>
                                                    </tr>
                                                    <tr>
                                                        <td height={5}/>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 21,
                                                                color: "#ff0000",
                                                                letterSpacing: "-1px",
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                lineHeight: 1,
                                                                verticalAlign: "top",
                                                                textAlign: "right"
                                                            }}
                                                        >
                                                            Számla
                                                        </td>
                                                    </tr>
                                                    <tr></tr>
                                                    <tr className="hiddenMobile">
                                                        <td height={10}/>
                                                    </tr>
                                                    <tr className="visibleMobile">
                                                        <td height={10}/>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 12,
                                                                color: "#5b5b5b",
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                lineHeight: 18,
                                                                verticalAlign: "top",
                                                                textAlign: "right"
                                                            }}
                                                        >
                                                            <small>Számla sorszáma: </small>{" "}
                                                            <strong>#HG-2024-0024</strong>
                                                            <br/>
                                                            <small>Kiállítás dátuma: </small>{" "}
                                                            <strong>2024-07-11</strong>
                                                            <br/>
                                                            <small>Ügyfél azonosító: </small>{" "}
                                                            <strong>#468-942</strong>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            {/* /Header */}
            {/* Information */}
            <table
                width="100%"
                border={0}
                cellPadding={0}
                cellSpacing={0}
                align="center"
                className="fullTable"
                bgcolor="#e1e1e1"
            >
                <tbody>
                <tr>
                    <td>
                        <table
                            width="100%"
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            align="center"
                            className="fullTable"
                            bgcolor="#ffffff"
                        >
                            <tbody>
                            <tr></tr>
                            <tr className="hiddenMobile">
                                <td height={60}/>
                            </tr>
                            <tr className="visibleMobile">
                                <td height={40}/>
                            </tr>
                            <tr>
                                <td>
                                    <table
                                        width="80%"
                                        border={0}
                                        cellPadding={0}
                                        cellSpacing={0}
                                        align="center"
                                        className="fullPadding"
                                    >
                                        <tbody>
                                        <tr>
                                            <td>
                                                <table
                                                    width={220}
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    align="left"
                                                    className="invoice-col"
                                                >
                                                    <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 11,
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                color: "#5b5b5b",
                                                                lineHeight: 1,
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            <strong>Számlázási információk</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="100%" height={10}/>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 12,
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                color: "#5b5b5b",
                                                                lineHeight: 20,
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            Mala Gastro Kft. - "Maharaja étterem"
                                                            <br/>
                                                            25989843-2-41
                                                            <br/> 2000 Szentendre, Duna korzó 11.
                                                            <br/>
                                                            <a
                                                                href="#"
                                                                style={{
                                                                    color: "#ff0000",
                                                                    textDecoration: "underline"
                                                                }}
                                                            >
                                                                szamla.maharaja@gmail.com
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                <table
                                                    width={220}
                                                    border={0}
                                                    cellPadding={0}
                                                    cellSpacing={0}
                                                    align="right"
                                                    className="invoice-col"
                                                >
                                                    <tbody>
                                                    <tr className="visibleMobile">
                                                        <td height={20}/>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 11,
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                color: "#5b5b5b",
                                                                lineHeight: 1,
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            <strong>Fizetési mód</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="100%" height={10}/>
                                                    </tr>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                fontSize: 12,
                                                                fontFamily: '"Open Sans", sans-serif',
                                                                color: "#5b5b5b",
                                                                lineHeight: 20,
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            Bankkártya
                                                            <br/> Visa, XXX-XXXX-XXX-1234
                                                            <br/> Tranzakció azonosítója:{" "}
                                                            <a
                                                                href="#"
                                                                style={{
                                                                    color: "#ff0000",
                                                                    textDecoration: "underline"
                                                                }}
                                                            >
                                                                4185939336
                                                            </a>
                                                            <br/>
                                                            Fizetve: 2024-07-11 12:52:32
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr className="hiddenMobile">
                                <td height={60}/>
                            </tr>
                            <tr className="visibleMobile">
                                <td height={30}/>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            {/* Order Details */}
            <table
                width="100%"
                border={0}
                cellPadding={0}
                cellSpacing={0}
                align="center"
                className="fullTable"
                bgcolor="#e1e1e1"
            >
                <tbody>
                <tr>
                    <td>
                        <table
                            width="100%"
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            align="center"
                            className="fullTable"
                            bgcolor="#ffffff"
                        >
                            <tbody>
                            <tr></tr>
                            <tr className="hiddenMobile">
                                <td height={60}/>
                            </tr>
                            <tr className="visibleMobile">
                                <td height={40}/>
                            </tr>
                            <tr>
                                <td>
                                    <table
                                        width="80%"
                                        border={0}
                                        cellPadding={0}
                                        cellSpacing={0}
                                        align="center"
                                        className="fullPadding"
                                    >
                                        <tbody>
                                        <tr>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#5b5b5b",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 10px 7px 0"
                                                }}
                                                width="35%"
                                                align="left"
                                            >
                                                Termék vagy szolgáltatás
                                            </th>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#5b5b5b",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 0 7px"
                                                }}
                                                align="center"
                                            >
                                                Mennyiség
                                            </th>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#5b5b5b",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 0 7px"
                                                }}
                                                align="center"
                                            >
                                                Nettó egységár
                                            </th>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 0 7px"
                                                }}
                                                align="right"
                                            >
                                                Áfakulcs
                                            </th>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 0 7px"
                                                }}
                                                align="right"
                                            >
                                                Nettó ár
                                            </th>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 0 7px",
                                                    width: 50
                                                }}
                                                align="right"
                                            >
                                                Áfa
                                            </th>
                                            <th
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    fontWeight: "normal",
                                                    lineHeight: 1,
                                                    verticalAlign: "top",
                                                    padding: "0 0 7px"
                                                }}
                                                align="right"
                                            >
                                                Bruttó össz.
                                            </th>
                                        </tr>
                                        <tr>
                                            <td
                                                height={1}
                                                style={{background: "#bebebe"}}
                                                colSpan={7}
                                            />
                                        </tr>
                                        <tr>
                                            <td height={13} colSpan={7}/>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#ff0000",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                className="article"
                                            >
                                                "Prémium" csomag havidíj
                                                <br/>
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0",
                                                    textAlign: "center"
                                                }}
                                            >
                                                1 hónap
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="center"
                                            >
                                                20 000 Ft
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                AAM
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                20 000 Ft
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                0 Ft
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                20 000 Ft
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={7}
                                                style={{
                                                    color: "#838383",
                                                    marginTop: "-5px",
                                                    paddingTop: 0
                                                }}
                                            >
                                                <small style={{fontSize: 11, marginTop: "-10px"}}>
                                                    Érvényesség: 2024-07-01 - 2024-07-31{" "}
                                                    <span style={{float: "right"}}>
                              Liszensz: 018febe4-04cd-7c1b-9fe2-490a27a2752c
                            </span>
                                                </small>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                height={1}
                                                colSpan={7}
                                                style={{borderBottom: "1px solid #e4e4e4"}}
                                            />
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#ff0000",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                className="article"
                                            >
                                                Mobil pincér app
                                                <br/>
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0",
                                                    textAlign: "center"
                                                }}
                                            >
                                                2 egység
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="center"
                                            >
                                                5 000 Ft
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                AAM
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                10 000 Ft
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                0 Ft
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#1e2b33",
                                                    lineHeight: 18,
                                                    verticalAlign: "top",
                                                    padding: "10px 0"
                                                }}
                                                align="right"
                                            >
                                                10 000 Ft
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                colSpan={7}
                                                style={{
                                                    color: "#838383",
                                                    marginTop: "-5px",
                                                    paddingTop: 0
                                                }}
                                            >
                                                <small style={{fontSize: 11, marginTop: "-10px"}}>
                                                    Érvényesség: 2024-07-01 - 2024-07-31{" "}
                                                    <span style={{float: "right"}}>
                              Liszensz: 018febe4-04cd-7c1b-9fe2-490a27a2752c
                            </span>
                                                </small>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                height={1}
                                                colSpan={7}
                                                style={{borderBottom: "1px solid #e4e4e4"}}
                                            />
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td height={20}/>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            {/* /Order Details */}
            {/* Total */}
            <table
                width="100%"
                border={0}
                cellPadding={0}
                cellSpacing={0}
                align="center"
                className="fullTable"
                bgcolor="#e1e1e1"
            >
                <tbody>
                <tr>
                    <td>
                        <table
                            width="100%"
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            align="center"
                            className="fullTable"
                            bgcolor="#ffffff"
                        >
                            <tbody>
                            <tr>
                                <td>
                                    {/* Table Total */}
                                    <table
                                        width="80%"
                                        border={0}
                                        cellPadding={0}
                                        cellSpacing={0}
                                        align="center"
                                        className="fullPadding"
                                    >
                                        <tbody>
                                        <tr>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                Részösszeg
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right",
                                                    whiteSpace: "nowrap"
                                                }}
                                                width={80}
                                            >
                                                30 000 Ft
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                Kedvezmény (10%)
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#646a6e",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                3 000 Ft
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#000",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                <strong>Bruttó összesen</strong>
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#000",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                <strong>27 000 Ft</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#b0b0b0",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                <small>Áfa (AAM)</small>
                                            </td>
                                            <td
                                                style={{
                                                    fontSize: 12,
                                                    fontFamily: '"Open Sans", sans-serif',
                                                    color: "#b0b0b0",
                                                    lineHeight: 22,
                                                    verticalAlign: "top",
                                                    textAlign: "right"
                                                }}
                                            >
                                                <small>0 Ft</small>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    {/* /Table Total */}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
            {/* /Total */}
            <div className="invoice-footer">
                <div className="happy">
                    <p>Üzemelteti a</p>
                    <span className="watermark">
        <img
            width="50px"
            src="data:image/png;base64,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"
            alt="Happy Gastro Éttermi szoftver"
        />
        <span>Happy Gastro™</span>
        <p>Éttermi szoftver</p>
        <p></p>
      </span>
                </div>
                <span className="nav-online">
      Készült a NAV Online számla szolgáltatásával
    </span>
            </div>
        </page>
    )
}